// extracted by mini-css-extract-plugin
export default {"viewSettingModal":"index_viewSettingModal__z1lHp"};